const pages = {
  FIRST: 'first',
  PREVIOUS: 'previous',
  NEXT: 'next',
  LAST: 'last',
  EXACT: 'exact'
};

export default pages;
